'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _Separator = require('../../common/Separator');

var _Separator2 = _interopRequireDefault(_Separator);

var _MedicalDetailsModal = require('../MedicalDetailsModal');

var _MedicalDetailsModal2 = _interopRequireDefault(_MedicalDetailsModal);

var _Application = require('./Application');

var _Application2 = _interopRequireDefault(_Application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ApplicationsList = (_dec = (0, _mobxReact.inject)('ApplicationStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(ApplicationsList, _Component);

  function ApplicationsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ApplicationsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ApplicationsList.__proto__ || Object.getPrototypeOf(ApplicationsList)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'application', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ApplicationsList, [{
    key: 'renderMedicalDetailModal',
    value: function renderMedicalDetailModal(application) {
      var UiStore = this.props.UiStore;


      this.application = application;
      UiStore.modals.MedicalDetails.open();
    }
  }, {
    key: 'renderApplication',
    value: function renderApplication(application) {
      var _props = this.props,
          _case = _props._case,
          onLienClick = _props.onLienClick,
          onCaseApplicationChanged = _props.onCaseApplicationChanged,
          applicationLien = _case.getLiens({ is_confirmed: false }).find(function (lien) {
        return lien.application === application.id;
      });

      return _react2.default.createElement(_Application2.default, {
        _case: _case,
        application: application,
        key: application.id,
        lien: applicationLien,
        onCaseApplicationChanged: onCaseApplicationChanged,
        onLienClick: onLienClick,
        priorFundings: _case.prior_fundings,
        renderMedicalDetailModal: this.renderMedicalDetailModal
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$_case = _props2._case,
          openApplications = _props2$_case.openApplications,
          rejectedApplications = _props2$_case.rejectedApplications,
          caseId = _props2$_case.id,
          UiStore = _props2.UiStore,
          emptyHTML = _react2.default.createElement(
        'div',
        { className: 'empty' },
        'There\'s no open application for this plaintiff.',
        _react2.default.createElement('br', null),
        'Click "New Application" button to get one started.'
      );

      return _react2.default.createElement(
        'div',
        { className: 'list-applications' },
        !openApplications.length ? emptyHTML : openApplications.map(this.renderApplication),
        !!rejectedApplications.length && _react2.default.createElement(_Separator2.default, { label: 'Rejected Applications' }),
        rejectedApplications.map(this.renderApplication),
        _react2.default.createElement(
          _reactTooltip2.default,
          { id: 'case-applications-no-contract', key: 'case-applications-no-contract', type: 'info', effect: 'solid', place: 'right', offset: { 'bottom': 1, 'right': 2 } },
          _react2.default.createElement(
            'span',
            null,
            'You must create a contract before changing the status to Funded.'
          )
        ),
        _react2.default.createElement(
          _reactTooltip2.default,
          { id: 'case-applications-no-move-back', key: 'case-applications-no-move-back', type: 'info', effect: 'solid', place: 'right', offset: { 'bottom': 1, 'right': 2 } },
          _react2.default.createElement(
            'span',
            null,
            'This application status',
            _react2.default.createElement('br', null),
            'cannot be moved back.'
          )
        ),
        _react2.default.createElement(
          _reactTooltip2.default,
          { id: 'case-applications-no-medical-codes', key: 'case-applications-no-medical-codes', type: 'info', effect: 'solid', place: 'right', offset: { 'bottom': 1, 'right': 2 } },
          _react2.default.createElement(
            'span',
            null,
            'You must add at least',
            _react2.default.createElement('br', null),
            'one medical code.'
          )
        ),
        UiStore.modals.MedicalDetails.showing() && _react2.default.createElement(_MedicalDetailsModal2.default, {
          caseId: caseId,
          onClose: UiStore.modals.MedicalDetails.close,
          lienId: (0, _get3.default)(this.application, 'lien.id')
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ApplicationsList;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  ApplicationStore: _propTypes2.default.object.isRequired,
  onCaseApplicationChanged: _propTypes2.default.func.isRequired,
  onLienClick: _propTypes2.default.func.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'application', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
})), _class2)) || _class) || _class) || _class);
var _default = ApplicationsList;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ApplicationsList, 'ApplicationsList', '/app/src/components/page-case/main-applications/ApplicationsList.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-applications/ApplicationsList.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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